<div class="tile__status" data-testid="tile"
    [ngClass]="{ 'tile__status--active': tile.params.workingStatus,
        'tile__status--inactive': !tile.params.workingStatus }">
    <div class="tile__img">
        <svg-icon src="/assets/img/icons/thermometer.svg"></svg-icon>
    </div>
    <floating-subtitle class="tile__subtitle"
        [ngClass]="{ 'tile__title--small': tile.elementMenu?.type === 7 }"
       [text]="subtitle(tile.params.txtId)">
    </floating-subtitle>
    <div class="tile__value">
        <p class="tile__value-set-temp font-18 color-default color-default--tile"
           data-testid="tile-value"
           *ngIf="tile.elementMenu?.type === 1">
           {{ tile.elementMenu.params.value*10 | format:7 }}
        </p>
        <p class="tile__value-set-temp font-18 color-default color-default--tile"
           data-testid="tile-value"
           *ngIf="tile.elementMenu?.type === 2">
           {{ tile.elementMenu.params.value | format:7 }}
        </p>
        <p class="tile__value-set-temp font-18 color-default color-default--tile"
           data-testid="tile-value"
           *ngIf="tile.elementMenu?.type === 7 && hasTimeValue(tile.elementMenu)">
           {{ (tile.elementMenu.params.timeValue | format:13) + ' ('
                + (tile.elementMenu.params.value | format:tile.elementMenu.params.type)
                + ')' }}
        </p>
        <p class="tile__value-current font-24 font-bold color-style"
           data-testid="working-status">
           {{ tile.params.workingStatus ? (tile.params.value | format:7) : '-&nbsp;-' }}
        </p>
    </div>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
           {{ subtitle(3162) }}
        </p>
    </div>
    <div class="hover-area hover-area--full-width"
         (click)="goControl()"
         [ngClass]="{ 'cursor-pointer': tile.elementMenu && tile.menuId !== 0 }"
         *ngIf="tile.params.batteryLevel !== null || tile.params.signalStrength !== null">
    </div>
    <div class="hover hover--full-width bg-dark-shadow box-shadow">
        <div class="hover__item color-light font-12"
            data-testid="battery-level"
            *ngIf="tile.params.batteryLevel !== null">
            <p class="hover__name">{{ subtitle(3581) }}</p>
            <p class="hover__value">
                {{ tile.params.batteryLevel | format:8 }}
            </p>
        </div>
        <div class="hover__item color-light font-12"
            data-testid="signal-strength"
            *ngIf="tile.params.signalStrength !== null">
            <p class="hover__name">{{ subtitle(689) }}</p>
            <p class="hover__value">
                {{ tile.params.signalStrength | format:8 }}
            </p>
        </div>
    </div>
</div>
